module.exports = __webpack_public_path__ + "img/checked.b0a54c30.svg";